import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { fetchAffiliatesByPos } from "../login/api.actions";
import { AffiliateDropdown } from "../components/structure/AffiliateDropdown";
import { updateCurrentAffiliate } from "../actions/affiliates";
import { fetchClients } from "../actions/clients";
import { Overlay } from "clorian-frontend-components";

class AffiliateHeaderContainer extends Component {
  constructor(props) {
    super(props);
    this.handleAffiliateChange = this.handleAffiliateChange.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(fetchClients()).then(() => {
      dispatch(fetchAffiliatesByPos()).then(({ response }) => {
        if (response && response[0])
          localStorage.setItem("id_pos", response[0].pointOfSaleId);
      });
    });
  }

  handleAffiliateChange(e, affiliateList) {
    affiliateList.forEach((x) => {
      if (e.value.pos === x.pointOfSaleId) {
        localStorage.setItem("id_pos", x.pointOfSaleId);
        this.affiliateChange(x.affiliate);
      }
    });
  }

  affiliateChange(currentAffiliate) {
    const { dispatch } = this.props;
    dispatch(updateCurrentAffiliate(currentAffiliate));
  }

  render() {
    const { affiliateList, loading } = this.props;

    return (
      <div className="affiliateSelector">
        <Fragment>
          <Overlay loading={loading} />
          {affiliateList && affiliateList.length > 0 && (
            <AffiliateDropdown
              affiliatesList={affiliateList}
              handleAffiliateChange={this.handleAffiliateChange}
            />
          )}
        </Fragment>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { affiliates, clients } = state;
  const affiliatesTmp = affiliates.affiliatesList
    ? [...affiliates.affiliatesList]
    : [];
  const loading =
    affiliates.affiliatesList && clients.clientList ? false : true;

  if (affiliatesTmp) {
    affiliatesTmp.forEach((aff) => {
      if (clients.clientList && clients.clientList.length > 0) {
        clients.clientList.forEach((cli) => {
          if (aff.affiliate.clientId === cli.clientId) {
            aff.affiliate.clientName = cli.name;
          }
        });
      }
    });

    return {
      affiliateList: affiliatesTmp,
      loading: loading,
    };
  }
};

export default connect(mapStateToProps)(AffiliateHeaderContainer);
